import React from 'react';
import { Card, Badge, Dropdown, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV, faEye, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { formatNumber } from '../redux/utils';

const MobileDataCard = ({ 
  title, 
  data, 
  primaryField, 
  secondaryFields = [], 
  actions = [],
  status,
  onActionClick = () => {}
}) => {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'approved': return 'success';
      case 'pending': return 'warning';
      case 'rejected': return 'danger';
      case 'created': return 'info';
      default: return 'secondary';
    }
  };

  const formatValue = (value, type) => {
    if (type === 'currency' && value) {
      return `₦${formatNumber(value)}`;
    }
    if (type === 'date' && value) {
      return new Date(value).toLocaleDateString();
    }
    return value || 'N/A';
  };

  return (
    <Card className="mobile-data-card mb-3 shadow-sm">
      <Card.Body className="p-3">
        {/* Header with Status */}
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="flex-grow-1">
            <h6 className="card-title mb-1 text-dark fw-semibold">{title}</h6>
            {status && (
              <Badge 
                bg={getStatusColor(status)} 
                className="status-badge"
              >
                {status}
              </Badge>
            )}
          </div>
          {actions.length > 0 && (
            <Dropdown align="end">
              <Dropdown.Toggle 
                variant="link" 
                className="text-muted p-0 border-0"
                style={{ boxShadow: 'none' }}
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {actions.map((action, index) => (
                  <Dropdown.Item 
                    key={index}
                    onClick={() => onActionClick(action.type, data)}
                  >
                    <FontAwesomeIcon 
                      icon={action.icon} 
                      className="me-2" 
                    />
                    {action.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
        
        {/* Primary Information */}
        {primaryField && (
          <div className="primary-info mb-3 p-2 bg-light rounded">
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-muted small fw-semibold">{primaryField.label}:</span>
              <span className="fw-bold fs-6 text-primary">
                {formatValue(primaryField.value, primaryField.type)}
              </span>
            </div>
          </div>
        )}
        
        {/* Secondary Information */}
        <div className="secondary-info">
          {secondaryFields.map((field, index) => (
            <div 
              key={index}
              className="d-flex justify-content-between py-2 border-bottom border-light"
            >
              <span className="text-muted small fw-medium">{field.label}:</span>
              <span className="small text-end" style={{ maxWidth: '60%' }}>
                {formatValue(field.value, field.type)}
              </span>
            </div>
          ))}
        </div>
        
        {/* Quick Actions */}
        {actions.length > 0 && (
          <div className="quick-actions mt-3 pt-2 border-top border-light">
            <div className="d-flex gap-2">
              {actions.slice(0, 2).map((action, index) => (
                <Button
                  key={index}
                  variant={action.variant || 'outline-primary'}
                  size="sm"
                  className="flex-fill"
                  onClick={() => onActionClick(action.type, data)}
                >
                  <FontAwesomeIcon icon={action.icon} className="me-1" />
                  {action.label}
                </Button>
              ))}
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default MobileDataCard;